 import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import { Configuration, BaseClass } from './../../app.constants';
import { HttpClient, HttpHeaders,HttpClientModule } from '@angular/common/http'; 
import DataSource from 'devextreme/data/data_source';    


export class GrievancessubmissionDetails {  
  GrievanceRequestID  :number; 
  GrievanceDate:Date;
  StudentID :number; 
  RequesterID :number; 
  AcademicInstanceID :number; 
  ExamInstanceID  :number; 
  GrievanceTypeID   :number; 
  TypeName:string;  
  Description:string;  
  DeleteFlag:number; 
  CreatedLoginID:number;  
  UpdatedLoginID:number;  
}
export class GrievancesTypeDetails {   
  GrievanceTypeID:number; 
  TypeName:string;    
}

@Injectable({
  providedIn: 'root'
})
export class GrievancessubmissionService {
  constructor(private http: HttpClient,private dataService: DataAccessService, private configuration : Configuration) { }
  public GrievancessubmissionServiceData: GrievancessubmissionService; 
  
  public GetPersonalInformation(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByID?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<GrievancessubmissionDetails[]>()
  }  
  public GetPreStudentGrievancesByStudentId(StudentID,PreStudentGrievancesID) {
    this.dataService.setControllerName = '/PreStudentGrievances/';
    this.dataService.setMethodName = 'GetPreStudentGrievancesByStudentId?StudentID='+ StudentID +'&PreStudentGrievancesID='+PreStudentGrievancesID + ""; // setting method name from API controller.
    return this.dataService.getAll<GrievancessubmissionDetails[]>()
  } 
  public GetGrievanceRequestByStudentID(StudentID,RequesterID,AcademicInstanceID) {
    this.dataService.setControllerName = '/GrievanceRequest/';
    this.dataService.setMethodName = 'GetGrievanceRequestByStudentID?StudentID='+ StudentID +'&RequesterID='+RequesterID +'&AcademicInstanceID='+AcademicInstanceID + ""; // setting method name from API controller.
    return this.dataService.getAll<GrievancessubmissionDetails[]>()
  } 
  public GetBasicGrievancesById(GrievanceTypeID) {
    this.dataService.setControllerName = '/GrievanceType/';
    this.dataService.setMethodName = 'GetGrievanceTypeList?GrievanceTypeID='+ GrievanceTypeID +""; // setting method name from API controller.
    return this.dataService.getAll<GrievancessubmissionDetails[]>()
  } 

  
  public PostInsertPreStudentGrievances(data) {debugger
    /* this.dataService.setControllerName = '/PreStudentGrievances/';
    this.dataService.setMethodName = 'PostInsertPreStudentGrievances';  */
    this.dataService.setControllerName = '/GrievanceRequest/';
    this.dataService.setMethodName = 'PostInsertGrievanceRequest'; 
    return this.dataService.add<GrievancessubmissionDetails[]>(data) 
  }
  public PostPreStudentGrievances(data) {debugger
    /* this.dataService.setControllerName = '/PreStudentGrievances/';
    this.dataService.setMethodName = 'PostPreStudentGrievances';  */
    this.dataService.setControllerName = '/GrievanceRequest/';
    this.dataService.setMethodName = 'PostGrievanceRequest'; 
    return this.dataService.add<GrievancessubmissionDetails[]>(data) 
  }
  public PostDeleteGrievanceRequest(data) {debugger
    this.dataService.setControllerName = '/GrievanceRequest/';
    this.dataService.setMethodName = 'PostDeleteGrievanceRequest'; 
    return this.dataService.add<GrievancessubmissionDetails[]>(data) 
  }

  uploadFile(fileToUpload: File,StudentID ,GrievanceRequestID,RequesterID){debugger 
        let formData: FormData = new FormData();  
        formData.append('file', fileToUpload, fileToUpload.name); 
        let headers = new HttpHeaders();  
          headers.append('Content-Type', 'form-data');
          headers.append('Accept', 'application/json'); 
          //headers.append('Authorization', 'Bearer ' + sessionStorage.getItem('auth_token'));       
          const httpOptions = {  
              headers: headers  
          }; 

        var queryParam="?StudentID=" + StudentID + "&GrievanceRequestID="+ GrievanceRequestID + "&RequesterID="+ RequesterID +"";
        let apiUrl = this.configuration.serverWithApiUrl +"/GrievanceRequest/UploadGrievanceSubmissionFile" + queryParam;
         
        return this.http
        .post(apiUrl, formData);
    }  
}

